import { Wine, Users } from "lucide-react";
import type { EventSpace } from "@/types/eventSpace";

interface EventSpaceDetailsProps {
  space: EventSpace;
}

export const EventSpaceDetails = ({ space }: EventSpaceDetailsProps) => {
  const getMinMaxPrice = (eventSpace: EventSpace) => {
    if (!eventSpace.pricing_tiers?.length) return null;
    
    const minSpend = Math.min(...eventSpace.pricing_tiers.map((tier) => tier.min_spend || 0));
    const maxSpend = Math.max(...eventSpace.pricing_tiers.map((tier) => tier.max_spend || 0));
    
    return { minSpend, maxSpend };
  };

  const pricing = getMinMaxPrice(space);

  return (
    <div className="flex flex-col gap-2 bg-accent/50 p-2 rounded-md">
      <div className="flex items-center justify-between">
        <span className="font-medium">{space.space_name}</span>
        {(parseInt(space.capacity || '0') || 0) > 0 && (
          <div className="flex items-center gap-2">
            <Users className="w-4 h-4" />
            <span>Up to {parseInt(space.capacity || '0')} guests</span>
          </div>
        )}
      </div>
      {space.amenities?.length > 0 && (
        <div className="flex flex-wrap gap-2">
          {space.amenities.map((amenityItem) => (
            <span
              key={amenityItem.amenity.id}
              className="inline-flex items-center gap-1 text-xs bg-background/50 px-2 py-1 rounded-full"
            >
              <Wine className="w-3 h-3" />
              {amenityItem.amenity.name}
            </span>
          ))}
        </div>
      )}
      {pricing && (
        <div className="text-xs text-muted-foreground">
          Minimum spend: ${pricing.minSpend.toLocaleString()} - ${pricing.maxSpend.toLocaleString()}
        </div>
      )}
    </div>
  );
};